/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  ActiveUsersBasedOnDrops,
  AverageDaysBetweenDrops,
  AverageDropSize,
  DropsNumberGraph,
  DropTrendlineChart,
  GeneralFilters,
  TotalStreamPercentage,
  VolumesGraphsChart,
} from "../../components";
import { useMarketPricing } from "../../store/useMarketPricing";
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";

function DropsStatsScreen() {
  /** Hooks */
  const { marketPrices, getAllMarketPrices } = useMarketPricing();
  /** State */
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [period, setPeriod] = useState<
    "Daily" | "Weekly" | "LastTwelweMonths" | "Monthly" | "Yearly"
  >("LastTwelweMonths");
  const [weeklyRange, setWeeklyRange] = useState(new Date());
  const [monthRange, setMonthRange] = useState(new Date());
  const [yearRange, setYearRange] = useState(new Date());

  /** Effects */
  useEffect(() => {
    getAllMarketPrices();
  }, []);

  useEffect(() => {
    setSelectedFilters([
      "All",
      ...(marketPrices?.length ? marketPrices?.map((price) => price.name) : []),
      "Total",
    ]);
  }, [marketPrices]);

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Drops Stats
        </h1>
        <div className="flex" />
      </div>
      {/* General filters */}
      <GeneralFilters
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        period={period}
        setPeriod={setPeriod}
        weeklyRange={weeklyRange}
        setWeeklyRange={setWeeklyRange}
        monthRange={monthRange}
        setMonthRange={setMonthRange}
        yearRange={yearRange}
        setYearRange={setYearRange}
      />
      {/* Posht grafiket */}
      <div className="flex flex-col sm:flex-row w-full">
        <DropsNumberGraph
          selectedFiltersProp={selectedFilters}
          periodProp={period}
          weeklyRangeProp={weeklyRange}
          monthRangeProp={monthRange}
          yearRangeProp={yearRange}
        />

        <DropTrendlineChart
          periodProp={period}
          weeklyRangeProp={weeklyRange}
          monthRangeProp={monthRange}
          yearRangeProp={yearRange}
          className="ml-5"
        />
      </div>

      <TotalStreamPercentage selectedFiltersProp={selectedFilters} />
      <ActiveUsersBasedOnDrops
        periodProp={period}
        monthRangeProp={monthRange}
      />
      <VolumesGraphsChart
        periodProp={period}
        weeklyRangeProp={weeklyRange}
        monthRangeProp={monthRange}
        yearRangeProp={yearRange}
      />
      <AverageDropSize
        selectedFiltersProp={selectedFilters}
        periodProp={period}
        weeklyRangeProp={weeklyRange}
        monthRangeProp={monthRange}
        yearRangeProp={yearRange}
      />
      <AverageDaysBetweenDrops selectedFiltersProp={selectedFilters} />
    </div>
  );
}

export default withProtectedRoute(DropsStatsScreen);
